import * as React from "react";
import { ProtectedRoute } from "@/components/auth";
import { DashboardContent } from "./components/DashboardContent";

export function DashboardPage() {
  return (
    <ProtectedRoute>
      <DashboardContent />
    </ProtectedRoute>
  );
}

export default DashboardPage;
